import { Injectable } from '@angular/core';
// import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  roles: string[] = [];

  constructor(private authService: AuthService, private _authService: AuthService ) {
    // this.authService.userData$.subscribe((userData) => {
    //   if (userData && userData.userData) {
    //     this.roles = userData.userData.roles || []; // Adjust based on your token's structure
    //   }
    // });
    
  }
    hasRole(role: string): boolean {

        this._authService.initRoles();

        this._authService.authName();

        this._authService.initUserPeId();

        return this._authService.roles()[0]?.toLocaleLowerCase().includes(role);

    }

    initData() {

        this._authService.initRoles();

        this._authService.authName();

        this._authService.initUserPeId();

    }

}
